import type { ColorChannelLegendModel } from '../../utils/scatterColors';
import { myTickFormat } from '../../utils/global';

export interface ScatterColorChannelLegendProps {
  model: ColorChannelLegendModel;
}

/**
 * Colour-ramp key for a scatter coloured "By Channel".
 *
 * The point colours come from a continuous scale over the channel's own extent, so without a ramp
 * the reader can see that a point is red but not what value red stands for. One compact row —
 * CHANNEL, the ramp, then the two bounds — pinned inside the plot's top-right corner.
 */
export default function ScatterColorChannelLegend(props: ScatterColorChannelLegendProps) {
  const minLabel = () => myTickFormat(props.model.min);
  const maxLabel = () => myTickFormat(props.model.max);
  const ariaLabel = () =>
    `Color scale for ${props.model.channelName}, from ${minLabel()} to ${maxLabel()}`;

  return (
    <div class="scatter-color-channel-legend" role="img" aria-label={ariaLabel()}>
      <span class="scatter-color-channel-legend__title">{props.model.channelName}</span>
      <div
        class="scatter-color-channel-legend__ramp"
        style={{ background: props.model.gradientCss }}
        aria-hidden="true"
      />
      <div class="scatter-color-channel-legend__range" aria-hidden="true">
        <span class="scatter-color-channel-legend__bound">{minLabel()}</span>
        <span class="scatter-color-channel-legend__dash">–</span>
        <span class="scatter-color-channel-legend__bound">{maxLabel()}</span>
      </div>
    </div>
  );
}
